import MyAxios from "@/utilize/MyAxios";
import { useMutation } from "@tanstack/react-query";

type TPayload = {
  adminId: string;
  profile: File;
};

const useUpdateProfile = () => {
  return useMutation({
    mutationFn: async ({ adminId, profile }: TPayload) => {
      const formData = new FormData();
      formData.append("profile", profile);

      return MyAxios.put(`/users/${adminId}/profile`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
  });
};

export default useUpdateProfile;
